import React, { useEffect } from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { queryClient } from '@client/init'
import { useAuthentication } from '@hooks/useAuthentication'
import { useUserAction } from '@hooks/user/useUserAction'
import { MyProfilePageProps } from './interface'

export function withMyProfilePage(Component: React.FC<MyProfilePageProps>) {
  function WithMyProfilePage() {
    const { user } = useAuthentication()
    const userClient = useUserAction()
    const router = useRouter()

    useEffect(() => {
      queryClient.invalidateQueries('my-profile')
    }, [])

    const { data: profile, isLoading } = useQuery(
      ['my-profile', user.profilePageSlug],
      () => userClient.getProfileBySlug(user.profilePageSlug),
      { enabled: !!user.id }
    )

    function handleActiveTabChange(tabId: string) {
      router.replace(
        {
          pathname: router.pathname,
          query: { tab: tabId },
        },
        undefined,
        { scroll: false }
      )
    }

    if (!profile || isLoading) {
      return null
    }

    const pageProps = {
      user: profile,
      profilePageSlug: user.profilePageSlug,
      handleActiveTabChange,
    }

    return <Component {...pageProps} />
  }

  return WithMyProfilePage
}
